<script setup lang="ts">
import { brandConfig } from '~/config/brand'

const colorMode = useColorMode()

const color = computed(() => (colorMode.value === 'dark' ? '#1b1718' : 'white'))

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color },
  ],
  link: [{ rel: 'icon', href: brandConfig.logo.favicon || '/favicon.ico' }],
  htmlAttrs: {
    lang: 'en',
  },
})

const title = brandConfig.app.title
const description = brandConfig.app.description

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: brandConfig.seo.ogImage,
  twitterImage: brandConfig.seo.twitterImage,
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <UApp>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
